import { AxiosResponse } from 'axios';

export interface DuplicateEntityInfo {
  duplicateId: string;
  originalId: string;
}

type DuplicateEntityCallback = (info: DuplicateEntityInfo) => void;

const createDuplicateEntityHandler = () => {
  let onDuplicateEntityFound: DuplicateEntityCallback | null = null;

  const handleDuplicateEntityHeader = (response: AxiosResponse): DuplicateEntityInfo | null => {
    const duplicateHeader = response.headers['gs-duplicate-entity-replaced'];

    if (duplicateHeader) {
      const duplicateMatch = duplicateHeader.match(/duplicateEntityId=([^;]+)/);
      const originalMatch = duplicateHeader.match(/originalEntityId=([^;]+)/);

      if (duplicateMatch && originalMatch) {
        const duplicateInfo: DuplicateEntityInfo = {
          duplicateId: duplicateMatch[1],
          originalId: originalMatch[1],
        };

        if (onDuplicateEntityFound) {
          onDuplicateEntityFound(duplicateInfo);
        }

        return duplicateInfo;
      }
    }

    return null;
  };

  const setOnDuplicateEntityFound = (callback: DuplicateEntityCallback) => {
    onDuplicateEntityFound = callback;
  };

  const clearCallback = () => {
    onDuplicateEntityFound = null;
  };

  return {
    handleDuplicateEntityHeader,
    setOnDuplicateEntityFound,
    clearCallback,
  };
};

export const duplicateEntityHandler = createDuplicateEntityHandler();
